<template lang='pug'>
.container-fluid.p-0.push-wrapper
	.container
		.row
			.col
				.row
					.col-12.my-header.font-weight-bold
						| Вопросы & Ответы

	.container.mt-5
		.white_block
			.row
				.col
					| Мы подготовили удобную страницу для ваших сотрудников, которые постоянно взаимодействуют с гостями.
					br
					| На этой странице есть ответы на большинство проблем, с которыми сталкиваются гости, хостес и администраторы в процессе эксплуатации карт и системы лояльности.
					br
					br
					div(v-if="shopPath")
						| Страница доступна по адресу:
						br
						br
						a(:href="`https://faq.wallet.actid.ru/?sp=${shopPath}`", target="_blank") https://faq.wallet.actid.ru/?sp={{ shopPath }}

						br
						| Просто передайте её сотруднику.
					div(v-else)
						| Загрузка ссылки...
</template>

<script>
	import { Tooltip } from "element-ui";
	import apiDriver from "../../apiDriver";

	export default {
		components: {
			[Tooltip.name]: Tooltip,
		},

		data() {
			return {
				shopPath: "",
			};
		},

		computed: {},

		mounted() {
			this.loadFormLink();
		},

		methods: {
			async loadFormLink() {
				let formlink_req = await apiDriver.services.api.get(
					"cards",
					"wallet/formlink"
				);
				this.shopPath = formlink_req.data.route;
			},
		},
	};
</script>
<style scoped lang="stylus">
	div {
		cursor: default;
	}

	a {
		margin-bottom: 2px;
		background: #3f51b5;
		color: white;
		padding: 5px 10px;
		border-radius: 5px;
		display: inline-block;

		&:hover {
			color: white;
		}

		&:focus {
			color: white;
		}
	}

	.my-header {
		font-size: 26pt;
	}

	.header-pre-push {
		font-size: 1.5rem;
	}

	.header-push {
		font-size: 1.5rem;
		color: black;
	}

	button.styled {
		margin-bottom: 5px;
		border: 1px solid #6c68cb;
		padding: 10px 15px;
		border-radius: 4px;
		color: #464384;
		cursor: pointer;
		background: white;

		&:hover {
			background: #6c68cb;
			color: white;
		}

		&[disabled] {
			border-color: #ddd;
			color: #ddd;
			cursor: default;
			background: white;
		}

		&:last-child {
			margin-bottom: 0;
		}
	}

	.design {
		background: white;
	}

	.inputModule {
		margin-bottom: 10px;

		&.extended {
			border-left: 4px solid #f4f3ef;
			padding-left: 15px;
			margin-left: 10px;
			padding-top: 10px;
		}
	}
</style>
